import RoastMyResume from './RoastMyResume';

function App() {
  return <RoastMyResume />;
}

export default App;